export const PAGINATION_LIMIT = 10;

export const TEST_QUEUE_IN_PAGE = {
  RECEPTIONIST: 1,
  TESTING: 2,
};

export const PRODUCT_TYPE = {
  ALL: 'ALL',
  SERVICE: 'SERVICE',
  MEDICINE: 'MEDICINE',
  GLASSES: 'GLASSES',
  FRAME: 'FRAME', // gọng kính
  LENS: 'LENS', // tròng kính
  OTHER: 'OTHER',
};

export const TESTING_STEP = {
  NEW: 0, // new user
  WAITING: 1, //  in test queue
  TEST: 2, // in testing screen ( submit testing with indicator, reason)
  DIAGNOSE: 3, // in diagnose screen (concluding, give a prescription)
  GLASS_MEDICINE_SERVICE: 4, // add service, glass, medicines
  /**
   * If customer is in CONFIRM_ORDER
   * can not update testing,
   * can not create new order from inprogress testing
   */
  CONFIRM_ORDER: 5,
  CANCELED: 6,
  DONE: 7,
  CANCEL_FROM_QUEUE: 8, // used to in test queue, but it was removed before add to testing
};

export const ORDER_STATUS = {
  All: 'ALL',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  PAID: 'PAID',
};

export const PERMISSIONS = {
  VIEW_CUSTOMER: 'VIEW_CUSTOMER',
  MANAGE_CUSTOMER: 'MANAGE_CUSTOMER',
  VIEW_PRODUCT: 'VIEW_PRODUCT',
  MANAGE_PRODUCT: 'MANAGE_PRODUCT',
  TEST_FLOW: 'TEST_FLOW',
  VIEW_ORDER: 'VIEW_ORDER',
  EDIT_ORDER: 'EDIT_ORDER',
  CREATE_ORDER: 'CREATE_ORDER',
  DELETE_ORDER: 'DELETE_ORDER',
  VIEW_ACCOUNT: 'VIEW_ACCOUNT',
  MANAGE_ACCOUNT: 'MANAGE_ACCOUNT',
  VIEW_RETEST_DATE: 'VIEW_RETEST_DATE',
  MANAGE_RETEST_DATE: 'MANAGE_RETEST_DATE',
  VIEW_STATS: 'VIEW_STATS',
  ALL: 'ALL',
};

export const ROLE_LABEL = {
  EMPLOYEE: 'Nhân viên',
};

export const ROLE_VALUE = {
  EMPLOYEE: 'EMPLOYEE',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const PERMISSION_LABEL = {
  VIEW_CUSTOMER: 'Xem khách hàng',
  MANAGE_CUSTOMER: 'Quản lý khách hàng',
  MANAGE_ACCOUNT: 'Quản lý tài khoản',
  VIEW_PRODUCT: 'Xem sản phẩm',
  MANAGE_PRODUCT: 'Quản lý sản phẩm',
  TEST_FLOW: 'Khám bệnh',
  VIEW_ORDER: 'Xem hóa đơn',
  VIEW_ACCOUNT: 'Xem tài khoản',
  EDIT_ORDER: 'Sửa hoá đơn',
  CREATE_ORDER: 'Tạo hoá đơn',
  DELETE_ORDER: 'Xoá hoá đơn',
  VIEW_RETEST_DATE: 'Xem lịch hẹn tái khám',
  VIEW_STATS: 'Xem thống kê',
  MANAGE_RETEST_DATE: 'Quản lý lịch hẹn tái khám',
  ALL: 'Tất cả quyền',
};

export const PERMISSION_OPTIONS = [
  {
    value: PERMISSIONS.VIEW_CUSTOMER,
    label: PERMISSION_LABEL.VIEW_CUSTOMER,
  },
  {
    value: PERMISSIONS.MANAGE_CUSTOMER,
    label: PERMISSION_LABEL.MANAGE_CUSTOMER,
  },
  {
    value: PERMISSIONS.VIEW_PRODUCT,
    label: PERMISSION_LABEL.VIEW_PRODUCT,
  },
  {
    value: PERMISSIONS.MANAGE_PRODUCT,
    label: PERMISSION_LABEL.MANAGE_PRODUCT,
  },
  {
    value: PERMISSIONS.VIEW_ORDER,
    label: PERMISSION_LABEL.VIEW_ORDER,
  },
  {
    value: PERMISSIONS.CREATE_ORDER,
    label: PERMISSION_LABEL.CREATE_ORDER,
  },
  {
    value: PERMISSIONS.EDIT_ORDER,
    label: PERMISSION_LABEL.EDIT_ORDER,
  },
  {
    value: PERMISSIONS.DELETE_ORDER,
    label: PERMISSION_LABEL.DELETE_ORDER,
  },
  {
    value: PERMISSIONS.VIEW_STATS,
    label: PERMISSION_LABEL.VIEW_STATS,
  },
  {
    value: PERMISSIONS.TEST_FLOW,
    label: PERMISSION_LABEL.TEST_FLOW,
  },
  {
    value: PERMISSIONS.VIEW_ACCOUNT,
    label: PERMISSION_LABEL.VIEW_ACCOUNT,
  },
  {
    value: PERMISSIONS.MANAGE_ACCOUNT,
    label: PERMISSION_LABEL.MANAGE_ACCOUNT,
  },
  {
    value: PERMISSIONS.VIEW_RETEST_DATE,
    label: PERMISSION_LABEL.VIEW_RETEST_DATE,
  },
  {
    value: PERMISSIONS.MANAGE_RETEST_DATE,
    label: PERMISSION_LABEL.MANAGE_RETEST_DATE,
  },
];

export const SELECT_ALL = {
  value: PERMISSIONS.ALL,
  label: PERMISSION_LABEL.ALL,
};

export const TESTING_STATUS = {
  INPROGRESS: 'INPROGRESS',
  DONE: 'DONE',
  CANCELED: 'CANCELED',
};

export const GENDER = {
  MALE: 'Nam',
  FEMALE: 'Nữ',
};

export const RETEST_DATE = {
  All: 'ALL',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
};

export const RETEST_DATE_TYPE = {
  SELECT: 'SELECT',
  DATEPICKER: 'DATEPICKER',
};

export const RETEST_DATE_OPTIONS = [
  { value: 0, label: 'Chọn ngày' },
  { value: 7, label: '1 tuần' },
  { value: 14, label: '2 tuần' },
  { value: 21, label: '3 tuần' },
  { value: 30, label: '1 tháng' },
  { value: 60, label: '2 tháng' },
  { value: 90, label: '3 tháng' },
  { value: 180, label: '6 tháng' },
];

export const ACCESS_TOKEN_KEY = 'accessToken';
